import React from 'react';
import {Card} from "../../../../components/card/card.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import TreeLanesInput from "../../../../components/tree-lanes/tree-lanes-input.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {MaskDefault} from "../../../../utils/mask.js";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaSearch} from "react-icons/fa";

const SearchFields = ({state, handleDate, onChange, clearFilter, search, treeLaneCheckedStatus, setTreeLaneCheckedStatus, inputCamerasValue, nodes, showModal, setShowModal}) => {
    return (
        <Card>
            <Card.Body>
                <div className="grid grid-cols-12 gap-4">
                    <div className="flex items-center col-span-4">
                        <div className="relative flex-1">
                            <InputDateTime
                                id={"dtStart"}
                                selected={state.dtStart}
                                label={"Data inicial *"}
                                onChange={(date) => handleDate(date, "dtStart")}
                                classNameWrapper={"right-date-input"}
                            />
                        </div>
                        <div
                            className="border border-[#E5E7EB] px-4 py-2 text-sm leading-none">
                            à
                        </div>
                        <div className="relative flex-1">
                            <InputDateTime
                                id={"dtEnd"}
                                selected={state.dtEnd}
                                label={"Data final *"}
                                onChange={(date) => handleDate(date, "dtEnd")}
                                classNameWrapper={"left-date-input"}
                            />
                        </div>
                    </div>

                    <div className="col-span-5">
                        <TreeLanesInput treeLaneCheckedStatus={treeLaneCheckedStatus}
                                        setTreeLaneCheckedStatus={setTreeLaneCheckedStatus}
                                        inputCamerasValue={inputCamerasValue.label}
                                        showModal={showModal} setShowModal={setShowModal}
                                        nodes={nodes}
                                        buttonLabel={"Confirmar"}
                                        title={"Seleção de câmeras"}
                                        className="cursor-pointer"/>
                    </div>

                    <div className="col-span-3 flex gap-4">
                        <InputForm id="plate" label="Placa" value={state.plate} onChange={onChange} classNameWrapper={"w-full"} inputClass={"uppercase"} mask={MaskDefault.plateWildcard}/>

                        <div className="flex gap-2">
                            <Button target="text-white" id="btn-clear" title="Limpar" className={"h-[32px]!"} onClick={() => clearFilter()}>
                                <FaEraser />
                            </Button>

                            <Button target="primary" id="btn-search" title="Buscar" className={"h-[32px]!"} onClick={() => search("1")}>
                                <FaSearch />
                            </Button>
                        </div>
                    </div>

                </div>
            </Card.Body>
        </Card>
    );
};

export default SearchFields;